import React from "react";

import { styled } from "@mui/material";

import { getMediaQuery } from "../../../../getMediaQuery";
import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";

interface ContainerProps {
  children?: React.ReactNode;
}

export const Container = ({ children }: ContainerProps) => {
  const { cartValue } = useProgressBarContext();
  return (
    <Root className={"ig-progress-bar"}>
      {cartValue !== undefined && children}
    </Root>
  );
};

const Root = styled("div")(() => {
  const { hasMediaQuery, device } = useProgressBarContext();

  return {
    ...(hasMediaQuery ? getMediaQuery(device.widget) : undefined),
    minWidth: "200px",
    maxWidth: "460px",
    width: "100%",
    padding: "10px 20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    rowGap: 16,
    margin: "auto",
  };
});
